import { Globe } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

export function SiteRoutingSection() {
  const [data, setData] = useState(null);
  const [pipeline, setPipeline] = useState("");
  useEffect(() => {
    api.get("/settings/site-routing").then(({ data: d }) => {
      setData(d);
      setPipeline(d.pipelines.find((p) => p.steps.some((s) => s.id === d.step_id))?.name || "");
    }).catch(() => setData(false));
  }, []);
  if (!data) return null;
  const save = async (patch) => {
    try { const { data: d } = await api.put("/settings/site-routing", { step_id: data.step_id, user_id: data.user_id, ...patch }); setData(d); toast.success("Destination des demandes du site enregistrée."); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur, réessayez."); }
  };
  const steps = data.pipelines.find((p) => p.name === pipeline)?.steps || [];
  return (
    <section className="settings-section" data-testid="site-routing-section">
      <div className="section-title"><Globe size={20} /><div><p className="eyebrow">SITE INTERNET</p><h2>Destination des demandes du site</h2></div></div>
      <p className="fileprep-dedup-hint">Chaque demande du formulaire ou de « Être rappelé » crée une opportunité noCRM à cet endroit, attribuée à ce commercial. Sans réglage, noCRM utilise son pipeline par défaut, sans commercial.</p>
      <div className="site-routing-grid">
        <label>Pipeline<select className="pl-select" value={pipeline} onChange={(e) => { setPipeline(e.target.value); const first = data.pipelines.find((p) => p.name === e.target.value)?.steps[0]; save({ step_id: first?.id || null }); }} data-testid="site-routing-pipeline"><option value="">Par défaut (noCRM)</option>{data.pipelines.map((p) => <option key={p.name} value={p.name}>{p.name}</option>)}</select></label>
        <label>Étape<select className="pl-select" value={data.step_id || ""} disabled={!pipeline} onChange={(e) => save({ step_id: Number(e.target.value) || null })} data-testid="site-routing-step">{steps.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</select></label>
        <label>Commercial<select className="pl-select" value={data.user_id || ""} onChange={(e) => save({ user_id: Number(e.target.value) || null })} data-testid="site-routing-user"><option value="">Non attribuée</option>{data.users.map((u) => <option key={u.user_id} value={u.user_id}>{u.name}</option>)}</select></label>
      </div>
    </section>
  );
}
